import { get } from 'lodash';

const url = window.location.origin;

export const getEnv = () => {
  switch (true) {
    case url.includes('one.cube.toyota.com'):
      return 'prod';
    case url.includes('one.cubeuat.toyota.com'):
      return 'uat';
    case url.includes('one.cubesit.toyota.com'):
      return 'sit';
    case url.includes('one.cubesit2.toyota.com'):
      return 'sit2';
    case url.includes('one.cubeqa.toyota.com'):
      return 'qa';
    case url.includes('one.cubeqa1.toyota.com'):
      return 'qa1';
    case url.includes('one.cubeqa2.toyota.com'):
      return 'qa2';
    case url.includes('one.cubedev2.toyota.com'):
      return 'dev2';
    case url.includes('one.cubedev.toyota.com'):
    case url.includes('localhost'):
    default:
      return 'dev';
  }
};

export const getBaseURL = () =>
  ({
    dev: 'one.cubedev.toyota.com',
    dev2: 'one.cubedev2.toyota.com',
    qa: 'one.cubeqa.toyota.com',
    qa1: 'one.cubeqa1.toyota.com',
    qa2: 'one.cubeqa2.toyota.com',
    uat: 'one.cubeuat.toyota.com',
    sit: 'one.cubesit.toyota.com',
    sit2: 'one.cubesit2.toyota.com',
    prod: 'one.cube.toyota.com',
  }[getEnv()]);

export const getIsVehicleDetailsPage = ({ pathname }) => {
  const pathParts = pathname.split('/').filter(Boolean);
  const firstPathPart = get(pathParts, '[0]');
  return firstPathPart === 'vehicle';
};
